import DeprecatedFeature from "../../components/deprecated-feature";

export default function Page() {
	return <DeprecatedFeature featureName="Certifications" />;
}
